/**
 * Primeiros passos (funil de ativação): a primeira entrega do Secretário acontece
 * antes de qualquer pedido genérico de permissão. O aviso só é pedido quando faz
 * sentido (ele acabou de criar um lembrete) e os contatos são oferecidos depois.
 */
const FIRST_DELIVERY_KEY = 'secretario.primeira-entrega';
const CONTACTS_OFFER_KEY = 'secretario.oferta-contatos';

/** Pede a folha de avisos com um motivo concreto (ex.: acabou de criar um lembrete). */
export const NOTIFY_ASK_EVENT = 'secretario:pedir-avisos';

function read(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* sem armazenamento: só esta sessão */
  }
}

export function firstDeliveryDone(): boolean {
  return read(FIRST_DELIVERY_KEY) === 'feita';
}

export function markFirstDelivery(): void {
  write(FIRST_DELIVERY_KEY, 'feita');
}

/** A oferta de trazer a agenda aparece uma vez, logo depois da primeira entrega. */
export function contactsOfferPending(): boolean {
  return read(CONTACTS_OFFER_KEY) !== 'vista';
}

export function markContactsOffer(): void {
  write(CONTACTS_OFFER_KEY, 'vista');
}

export function askNotifications(reason: string): void {
  window.dispatchEvent(new CustomEvent(NOTIFY_ASK_EVENT, { detail: { reason } }));
}
